import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { usePersistentTab } from '../../hooks/usePersistentTab';
import OperacionesUnidades from './tabs/OperacionesUnidades';
import OperacionesSalas from './tabs/OperacionesSalas';
import OperacionesLimites from './tabs/OperacionesLimites';
import OperacionesConfig from './tabs/OperacionesConfig';

export default function OperacionesEdificioDetalle({ edificioId: edificioIdProp, hideBack }) {
  const params = useParams();
  const edificioId = edificioIdProp || params.edificioId;
  const navigate = useNavigate();
  const [tab, setTab] = usePersistentTab('tab', 'unidades');

  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto">
      {!hideBack && (
        <button
          onClick={() => navigate('/operaciones')}
          className="text-xs text-slate-500 hover:text-slate-700 inline-flex items-center gap-1 mb-3"
        >
          <ChevronLeft className="w-3 h-3" /> Volver
        </button>
      )}

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-transparent gap-1 mb-4">
          <TabsTrigger value="unidades" data-testid="tab-unidades">
            <span className="text-slate-400 mr-1.5 text-xs">1</span> Unidades & Usuarios
          </TabsTrigger>
          <TabsTrigger value="salas" data-testid="tab-salas">
            <span className="text-slate-400 mr-1.5 text-xs">2</span> Salas
          </TabsTrigger>
          <TabsTrigger value="limites" data-testid="tab-limites">
            <span className="text-slate-400 mr-1.5 text-xs">3</span> Límites
          </TabsTrigger>
          <TabsTrigger value="config" data-testid="tab-config">
            <span className="text-slate-400 mr-1.5 text-xs">4</span> Configuración
          </TabsTrigger>
        </TabsList>

        <TabsContent value="unidades"><OperacionesUnidades edificioId={edificioId} /></TabsContent>
        <TabsContent value="salas"><OperacionesSalas edificioId={edificioId} /></TabsContent>
        <TabsContent value="limites"><OperacionesLimites edificioId={edificioId} /></TabsContent>
        <TabsContent value="config"><OperacionesConfig edificioId={edificioId} /></TabsContent>
      </Tabs>
    </div>
  );
}
